<template>
  <a-drawer
    :title="title"
    :width="width"
    :visible="visible"
    :confirmLoading="confirmLoading"
    :destroyOnClose="true"
    :maskClosable="true"
    placement="right"
    @close="close"
    cancelText="关闭"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item
          label="人群标签ID"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            type="text"
            :max-length="50"
            v-decorator="[
              'crowdId',
              {
                rules: [
                  { required: true, message: '请输入人群标签id,限制50个字' },
                ],
              },
            ]"
            placeholder="请输入人群标签id,限制50个字"
          />
        </a-form-item>
        <a-form-item
          label="人群标签名称"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            type="text"
            :max-length="50"
            v-decorator="[
              'crowdName',
              {
                rules: [
                  { required: true, message: '请输入人群标签名称,限制50个字' },
                ],
              },
            ]"
            placeholder="请输入人群标签名称,限制50个字"
          />
        </a-form-item>
        <!--<a-form-item  label="模板类型" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-select  v-decorator="['templateType', { rules: [{ required: true, message: '请选择模板类型' }] }]" placeholder="请选择模板类型" @change="templateTypeHandle">
            <a-select-option v-if="templateTypeList != null" v-for="(item, index) in templateTypeList" :value="item.value" :key="index">{{item.name}}</a-select-option>
          </a-select>
        </a-form-item>-->
        <a-form-item
          label="模板消息"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-select
            v-decorator="[
              'templateId',
              { rules: [{ required: true, message: '请选择模板' }] },
            ]"
            @change="messageIdHandle"
            placeholder="请选择模板"
          >
            <a-select-option
              v-for="(item, index) in messageIds"
              :value="item.id"
              :key="index"
              >{{ item.templateName }}</a-select-option
            >
          </a-select>
        </a-form-item>
        <!--<a-form-item label="状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-dict-select-tag v-decorator="['status']" placeholder="请选择规则状态" :triggerChange="true" dictCode="obj_status"/>
        </a-form-item>-->
      </a-form>
    </a-spin>
    <div class="drawer-bootom-button">
      <a-popconfirm
        title="确定放弃编辑？"
        @confirm="handleCancel"
        okText="确定"
        cancelText="取消"
      >
        <a-button style="margin-right: 0.8rem">取消</a-button>
      </a-popconfirm>
      <a-button @click="handleOk" type="primary">提交</a-button>
    </div>
  </a-drawer>
</template>

<script>
import { httpAction } from '@/api/manage';
import pick from 'lodash.pick';
import JDate from '@/components/jeecg/JDate';
import JImageUpload from '@/components/jeecg/JImageUpload';
import JMultiSelectTag from '../../../../components/dict/JMultiSelectTag';
import moment from 'moment';
import { getAction } from '../../../../api/manage';

export default {
  name: 'MarketCrowdPushModal',
  components: {
    JMultiSelectTag,
    JDate,
    JImageUpload,
  },
  data() {
    return {
      showEditor: false,
      showUpload: false,
      editorOption: {
        modules: {
          toolbar: [
            [
              'bold',
              { header: 1 },
              { header: 2 },
              { color: [] },
              { font: [] },
              { size: ['small', false, 'large', 'huge'] },
              'italic',
              'underline',
              'strike',
            ], // toggled buttons
            [
              'blockquote',
              { indent: '-1' },
              { indent: '+1' },
              { align: [] },
              'clean',
            ],
          ],
        },
      },
      headers: {
        authorization: 'authorization-text',
      },
      category: '0',
      form: this.$form.createForm(this),
      title: '操作',
      width: 800,
      visible: false,
      messageIds: [],
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      confirmLoading: false,
      validatorRules: {},
      url: {
        add: process.env.VUE_APP_CMS_MARKETING + '/crowdPush/add',
        edit: process.env.VUE_APP_CMS_MARKETING + '/crowdPush/edit',
        getMessageIdList:
          process.env.VUE_APP_CMS_MARKETING + '/messageTemplate/all',
      },
    };
  },
  created() {
    this.getMessageIdList();
  },
  methods: {
    moment,
    add() {
      this.edit({});
    },
    edit(record) {
      this.form.resetFields();
      this.model = Object.assign({}, record);
      this.visible = true;

      this.$nextTick(() => {
        this.form.setFieldsValue(
          pick(this.model, 'crowdId', 'crowdName', 'templateType', 'templateId')
        );
      });
    },
    close() {
      this.$emit('close');
      this.visible = false;
    },
    handleOk() {
      const that = this;
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true;
          let httpurl = '';
          let method = '';
          if (!this.model.id) {
            httpurl += this.url.add;
            method = 'post';
          } else {
            httpurl += this.url.edit;
            method = 'put';
          }
          let formData = Object.assign(this.model, values);
          console.log('表单提交数据', formData);
          httpAction(httpurl, formData, method)
            .then((res) => {
              if (res.success) {
                that.$message.success(res.message);
                that.$emit('ok');
              } else {
                that.$message.warning(res.message);
              }
            })
            .finally(() => {
              that.confirmLoading = false;
              that.close();
            });
        }
      });
    },
    handleCancel() {
      this.close();
    },
    popupCallback(row) {
      this.form.setFieldsValue(
        pick(row, 'crowdId', 'crowdName', 'templateType', 'templateId')
      );
    },

    onEditorBlur() {
      //失去焦点事件
    },
    onEditorFocus() {
      //获得焦点事件
    },
    onEditorChange() {
      //内容改变事件
    },
    messageIdHandle() {
      this.messageIds = [];
      this.getMessageIdList();
    },
    /**获取模板列表*/
    getMessageIdList() {
      getAction(this.url.getMessageIdList, { type: '1' }).then((res) => {
        if (res.success) {
          this.messageIds = res.result;
          console.log(this.messageIds);
        }
      });
    },

    templateTypeHandle(e) {
      if (e === '1' || e === '2') {
        this.messageIds = [];
        this.getMessageIdList(e);
        //this.showPrizeList = true;
      } else {
        this.messageIds = [];
        //this.showPrizeList = false;
      }
    },
  },
};
</script>
